import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const SendBackIcon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeWidth={strokeWidth}
            d="M17 13.5V9a2 2 0 0 0-2-2h-4.5m3 10H9a2 2 0 0 1-2-2v-5m-3 0h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2Zm12 12h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2Z"
        />
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeWidth={strokeWidth}
            d="M17 13.5V9a2 2 0 0 0-2-2h-4.5m3 10H9a2 2 0 0 1-2-2v-5m-3 0h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2Zm12 12h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2Z"
        />
    </svg>
);
export { SendBackIcon };
